import { render, staticRenderFns } from "./WarningsView.vue?vue&type=template&id=cb018692"
import script from "./WarningsView.vue?vue&type=script&lang=js"
export * from "./WarningsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports